import React, { useState, useEffect } from 'react';
import SingleMetric from './SingleMetric';
import FundsChart from './FundsChart';
import PortcoChart from './PortcoChart';
import FundStats from './FundStats';
import InvestmentChart from './InvestmentChart';
import MonthlyInvestmentChart from './MonthlyInvestmentChart';
import './dashboard.css';
import "../../common/css/layout.css";
import "../../common/css/charts.css";
import { fetchDashboardMetrics, getFunds, getFundsWithInvestments, helpGetAffinityList } from '../../common/helpers/DashboardHelper';
import { formatCurrency } from '../../common/util/dataFormatterUtils';
import AffinityStatusChart from './AffinityStatusChart';
import FundSelector from '../components/FundSelector';

const Dashboard = () => {
    const [metrics, setMetrics] = useState(null);
    const [fundStats, setFundStats] = useState(null);
    const [funds, setFunds] = useState(null);
    const [fundsWithInvestments, setFundsWithInvestments] = useState(null);
    const [investments, setInvestments] = useState(null);
    const [affinityList, setAffinityList] = useState(null);
    const [selectedFund, setSelectedFund] = useState(null);


    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchDashboardMetrics(selectedFund ? selectedFund.internal_fund_id : null);

            if (data) {
                setMetrics(data.metrics);
                setFundStats(data.fundStats);
                setInvestments(data.investmentData);
            }
        }
        fetchData();
    }, [selectedFund]);

    useEffect(() => {
        const fetchFundsData = async () => {
            const fundsData = await getFunds(selectedFund ? selectedFund.internal_fund_id : null);
            setFunds(fundsData);
        }
        fetchFundsData();
    }, [selectedFund]);

    useEffect(() => {
        const fetchAffinityList = async () => {
            const affinityList = await helpGetAffinityList(selectedFund ? selectedFund.affinity_list_id : null);
            setAffinityList(affinityList);
        }
        fetchAffinityList();
    }, [selectedFund]);

    useEffect(() => {
        const fetchFundsWithInvestments = async () => {
            const fundsWithInvestments = await getFundsWithInvestments();
            setFundsWithInvestments(fundsWithInvestments);
        }
        fetchFundsWithInvestments();
    }, []);

    const onFundSelect = (fund) => {
        setSelectedFund(fund); // Update the state variable with the selected fund
      };

    return (
        <div className="all-components-container">
            <div className="component-no-border-left component-in-row-3">
                <FundSelector onFundSelect={onFundSelect}/>
            </div>
            <div className="component-no-border component-in-row-3"></div>
            <div className="component-no-border component-in-row-3"></div>
            <div className="hr_line"></div>
            {metrics ? (
                <>
                    <div className="component component-in-row-5">
                        <SingleMetric metricLabel="Number of Funds" metricValue={metrics.numberOfFunds} />
                    </div>
                    <div className="component component-in-row-5">
                        <SingleMetric metricLabel="Number of Portfolio Companies" metricValue={metrics.numberOfPortfolioCompanies} />
                    </div>
                    <div className="component component-in-row-5">
                        <SingleMetric metricLabel="Current AUM" metricValue={formatCurrency(metrics.currentAUM)} />
                    </div>
                    <div className="component component-in-row-5">
                        <SingleMetric metricLabel="Total Invested Capital" metricValue={formatCurrency(metrics.totalInvestedCapital)} />
                    </div>
                    <div className="component component-in-row-5">
                        <SingleMetric metricLabel="Total Available to Invest" metricValue={formatCurrency(metrics.totalAvailableToInvest)} />
                    </div>
                </>
            ) : (
                <p>Loading...</p>
            )}
            {funds ? (
                <div className="component component-in-row-2">
                    {funds && <FundsChart data={funds} />}
                </div>
            ) : (
                <p>Loading...</p>
            )}
            {fundsWithInvestments ? (
                <>
                    <div className="component component-in-row-4">
                        
                    </div>
                </>
            ) : (
                <p>Loading...</p>
            )}
            {fundStats ? (
                <>
                    <div className="component component-in-row-4">
                        <FundStats fundStats={fundStats}  selectedFund={selectedFund}/>
                    </div>
                    
                </>
            ) : (
                <p>Loading...</p>
            )}
            {investments ? (
                <>
                <div className="component component-in-row-2">
                <div className="component-heading-light">
                        Investments By Portfolio Company
                    </div>
                    <InvestmentChart data={investments} />
                </div>
                <div className="component component-in-row-2">
                    <div className="component-heading-light">
                        Investments By Month
                    </div>
                    <MonthlyInvestmentChart investmentData={investments} />
                </div>
            </>
            ) : (
                <p>Loading...</p>
            )}

            {affinityList ? (
                <>
                <div className="component component-in-row-4">
                    <div className="component-heading-light">
                        Total Companies that IC evaluated
                    </div>
                    <AffinityStatusChart affinityList={affinityList} />
                    <div className="chart-source-heading-light">
                    Data Source: Affinity
                    </div>
                </div>
            </>
            ) : (
                <p>Loading...</p>
            )}

        </div>
    );
}

export default Dashboard;
